var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNavigationArrow = function SvgIconNavigationArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.791 2.562h.003l15.864 5.492h.002c1.619.557 1.538 2.83-.057 3.326l-7.052 2.175-2.17 7.046-.001.002c-.496 1.595-2.77 1.676-3.325.057l-.001-.002L2.563 4.794l-.001-.003a1.75 1.75 0 0 1 2.23-2.23m-1.285 1.9.945-.327-.001-.004zm1.112.156 14.665 5.076-6.428 1.983a1.7 1.7 0 0 0-1.176 1.162l-1.985 6.443zM9.946 20.01v.001m3.653-6.61-.001.006z",
    clipRule: "evenodd"
  })));
};
export default SvgIconNavigationArrow;